import React from 'react'
import styled from 'styled-components'
import { ShallowManualEntry } from '../types.graphql'
import { TableMenu } from 'components'
import { Menu } from 'components/Table/TableMenu'
import { Link } from 'react-router-dom'
import { useDateFns } from 'util/hooks'
import { Icon } from 'ur-react-components'
import { FolderPath } from './FolderPath'

const Wrapper = styled.section`
  margin-top: 1rem;

  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`
const Header = styled.header`
  display: grid;
  grid-template-columns: 1fr 1fr;

  border-bottom: 1px ${props => props.theme.colors.gray6} solid;

  & > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0.5rem 1rem;

    &.menus {
      justify-content: flex-end;

      i {
        transform: translateY(1px);
      }
    }
  }
`
const DateField = styled.div`
  padding: 0 1rem;

  color: ${props => props.theme.colors.gray3};
  font-size: 14px;
  font-weight: 600;
`
const Title = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 1rem;

  width: 100%;
  padding: 1rem;

  a {
    display: flex;
    align-items: center;
    gap: 1rem;

    font-size: 18px;
    font-weight: 600;
  }
`
const Description = styled.div`
  padding: 1rem;

  color: ${props => props.theme.colors.gray1};
  font-size: 0.9rem;

  border-top: 1px ${props => props.theme.colors.gray6} solid;
`

interface EntryCardProps {
  entry: ShallowManualEntry

  editDeleteMenu: TableMenu
  orderArrows: JSX.Element | null
  showPath?: boolean

  onResetSearch?: () => void
}

export const EntryCard: React.FC<EntryCardProps> = ({
  entry,

  editDeleteMenu,
  orderArrows,
  showPath = false,

  onResetSearch = () => void 0,
}) => {
  const { format } = useDateFns()

  return (
    <Wrapper>
      <Header>
        <DateField>{format(new Date(entry.updatedAt), 'PPP')}</DateField>

        <div className="menus">
          <Menu icon="ellipsis-h" config={editDeleteMenu} />
        </div>
      </Header>

      <Title>
        <Link to={`/handbook/${entry.folder.slug}/${entry.slug}`}>
          <Icon icon="file" type="solid" size="25px" />
          {entry.name}
        </Link>

        {orderArrows}
      </Title>

      {!!entry.description && <Description>{entry.description}</Description>}

      {showPath && !!entry.path && (
        <Description>
          <FolderPath folders={entry.path} onGoToRoot={onResetSearch} />
        </Description>
      )}
    </Wrapper>
  )
}
